import { ref, provide } from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import AICopilot from './components/AICopilot.vue';
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    AICopilot
  },
  setup() {
    const copilotOpen = ref(false);
    const toggleAICopilot = () => {
      copilotOpen.value = !copilotOpen.value;
      console.log('AI Copilot toggled:', copilotOpen.value);
    };
    provide('copilotOpen', copilotOpen);
    provide('toggleAICopilot', toggleAICopilot);
    return {
      copilotOpen,
      toggleAICopilot
    };
  }
};